export default "__VITE_ASSET__Egno9Oie__"